import { Media } from "../types/media";
import { ArticleWithMediaCount } from "../types/article";

export const formatHfbTitle = (
  hfb: string,
  t: (key: string, options?: any) => string
) => {
  if (hfb.match(/^[0-9]{2}$/)) {
    return t(`hfbFilterOptionString`, { hfb }) + " - " + t(`hfb${hfb}String`);
  }
  if (hfb === "OTHER") {
    return t("hfbOTHERString");
  }
  return hfb;
};

export const filterMediasByArticleHfb = (
  medias: Media[],
  articlesFromHfb: ArticleWithMediaCount[] | null | undefined
): Media[] => {
  if (!articlesFromHfb) {
    return [];
  }

  const mediaIds = new Set(articlesFromHfb.map((article) => article.mediaId));
  return medias.filter((media) => mediaIds.has(media.id));
};
